export default function CampSection() {
  const features = [
    {
      icon: 'ri-fire-fill',
      title: '大自然の中での感動体験',
      description:
        '森に囲まれたロケーションでの研修、レクリエーションはもちろん、夜には大人数で楽しめるキャンプファイヤーも可能。仲間との絆を深める特別な時間をお過ごしいただけます。',
      image: 'https://public.readdy.ai/ai/img_res/5b0e210c528b5809026ca735ed19faf7.jpg',
    },
    {
      icon: 'ri-building-fill',
      title: '体育館を完備',
      description:
        'あさぎり荘では、専用体育館を完備しています。雨天時でも練習ができ、合宿のスケジュールを無駄なく活用していただけます。卓球、ダンス、武道（剣道など）、練習、発表練習に最適です。',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/b7e521ef2c847a40facc6aa0454f00a4.jpeg',
    },
    {
      icon: 'ri-bus-fill',
      title: '団体利用に最適な受け入れ環境',
      description:
        '学校・部活動・サークル・地域団体など、規模に応じた特別料金プランをご用意しています。大人数の宿泊に対応し、地元食材の田舎料理をご提供。バスでの来館も安心の広い駐車スペースを完備しています。',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/085d64803664008afdc71a27b1d1b0c6.png',
    },
  ];

  return (
    <section id="camp" className="py-20 md:py-32 px-6 bg-forest-800 relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto relative">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gold-400 mb-3">
            合宿のご案内
          </h2>
          <p className="text-white/80 text-lg">Camp Information</p>
          <div className="w-24 h-1 bg-gold-600 mx-auto mt-6"></div>
        </div>

        <p className="text-white/90 text-center max-w-3xl mx-auto mb-16 leading-relaxed text-base">
          ハチ高原「あさぎり荘」は、スポーツ合宿や研修・文化系合宿など、さまざまな目的に合わせてご利用いただける宿泊施設です。自然豊かな環境と充実した設備で、学生のみなさまの思い出に残る時間をサポートします。
        </p>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-full h-[280px] rounded-xl overflow-hidden mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-gold-600 rounded-full mb-4">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="font-serif text-xl font-semibold text-white mb-4">
                {feature.title}
              </h3>
              <p className="text-white/80 leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 text-center">
          <h3 className="font-serif text-2xl md:text-3xl font-semibold text-white mb-4">
            まずはお気軽にご相談ください
          </h3>
          <p className="text-white/80 mb-8 leading-relaxed text-base">
            料金・日程・施設利用など、お客様に合わせて最適なプランをご提案します。
            <br />
            スポーツ以外の目的での合宿も歓迎いたします。
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="tel:079-667-8119"
              className="inline-flex items-center px-8 py-3.5 bg-gold-600 text-white text-base font-medium rounded-full hover:bg-gold-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              TEL: 079-667-8119
            </a>
            <div className="inline-flex items-center px-8 py-3.5 bg-white/20 text-white text-base font-medium rounded-full whitespace-nowrap">
              <i className="ri-printer-line mr-2"></i>
              FAX: 079-667-8158
            </div>
          </div>

          <div className="bg-white/10 rounded-xl p-6 text-left max-w-2xl mx-auto">
            <h4 className="font-semibold text-white mb-4 text-base">
              お問い合わせ時にご準備いただきたい内容
            </h4>
            <ul className="space-y-2 text-white/80 text-sm">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>団体名（学校名・サークル名 など）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>人数（生徒：○名／先生：○名）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>合宿の内容・目的</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>期間</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>利用したい施設（体育館・テニスコート・グラウンド など）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-gold-400 mr-2 mt-1"></i>
                <span>施設利用希望日時</span>
              </li>
            </ul>
          </div>

          <p className="text-white/70 text-sm mt-6">
            先生方・幹事さんへ：事前の下見、打ち合わせに対応いたします。学生の皆様の合宿を応援するため、一般の料金とは異なるお得な特別な料金を設定しています。
          </p>
        </div>
      </div>
    </section>
  );
}